import vue2Dropzone from "vue2-dropzone";

import { mapGetters } from "vuex";

import "vue2-dropzone/dist/vue2Dropzone.min.css";

import CloseIcon from "@/assets/images/icons/close.svg?inline";

import {
  REMOVE_ID_DOCUMENT,
  REMOVE_PROPERTY_PHOTO
} from "./gql/UploadDocuments";

export default {
  name: "identity_documents",

  data() {
    return {
      dropzoneOptions: {
        url: process.env.VUE_APP_API,
        thumbnailWidth: 106,
        thumbnailHeight: 80,
        maxFilesize: 10,
        maxFiles: 10,
        acceptedFiles: "image/*,application/pdf",
        headers: {
          authorization: `Bearer ${localStorage.getItem("AUTH_TOKEN")}`
        },
        dictDefaultMessage: "Choose a file to upload",
        addRemoveLinks: true,
        paramName: "variables[file]"
      },
      isDestroying: false,

      tempPropertyPhotos: []
    };
  },

  props: {
    destination: {
      type: String,
      default: "agent_documents" // "agent_documents" || "property_photos"
    },

    propertyPhotos: {
      type: Array,
      default: () => []
    },

    propertyId: {
      type: String,
      default: ""
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    uploadedFiles() {
      if (this.destination === "agent_documents") {
        return this.currentUser.agentDocuments;
      } else {
        // IF this.destination === "property_photos"
        return this.propertyPhotos;
      }
    }
  },

  methods: {
    sendingEvent(file, xhr, formData) {
      if (this.destination === "agent_documents") {
        formData.append(
          "query",
          "mutation { agentDocuments { agentDocument { id file } } }"
        );
        formData.append(
          "graphql[query]",
          "mutation { agentDocuments { agentDocument { id file}  } }"
        );
      } else {
        // IF this.destination === "property_photos"
        formData.append(
          "query",
          `mutation { addPropertyPhoto(propertyId: ${this.propertyId}) { photo { id, image } } }`
        );
      }
    },

    removeIDFile(doc) {
      this.$apollo
        .mutate({
          mutation:
            this.destination === "agent_documents"
              ? REMOVE_ID_DOCUMENT
              : REMOVE_PROPERTY_PHOTO,
          variables: {
            id: doc.id,
            removeFile: true,
            propertyId:
              this.destination === "property_photos" ? this.propertyId : null
          }
        })

        .then(({ data }) => {
          let files = [];
          if (this.destination === "agent_documents") {
            files = this.currentUser.agentDocuments;
          } else {
            // IF this.destination === "property_photos"

            files = this.propertyPhotos;
          }
          let index = files.findIndex(d => d.id === doc.id);

          files.splice(index, 1);
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
            this.errorTitle = errors[error].message;
          }
          this.isTokenInvalid = true;
        });
    },

    uploadedFile(file, response) {
      if (this.destination === "agent_documents") {
        this.$store.commit(
          "setUserIDocuments",
          response.data.agentDocuments.agentDocument
        );

        this.$refs.documentsDropzone.removeFile(file);

        file.dzId = response.data.agentDocuments.agentDocument.id;
      } else {
        // IF this.destination === "property_photos"
        this.propertyPhotos.push(response.data.addPropertyPhoto.photo);

        this.$refs.documentsDropzone.removeFile(file);

        file.dzId = response.data.addPropertyPhoto.photo.id;
      }
    }
  },

  components: {
    vueDropzone: vue2Dropzone,
    CloseIcon
  },

  beforeDestroy() {
    this.isDestroying = true;
  }
};
